import { Component } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

import { map, of, throwError, timer } from 'rxjs';

import { ContactProfileCardComponent } from '@camelot/core';
import { CamContactService } from '@camelot/services';

import { TestIdDirective } from '@camelot/testing-harness';

const contactMock = {
  firstName: 'Slow',
  id: 'slow',
  lastName: 'Contact',
  mail: 'slow@example.com',
  phoneNumber: '+3210000000',
};

const contactServiceMock = {
  fetchContactById$: () => of(contactMock),
  fetchDynamicProps$: (id: string) => {
    if (id === 'slow') {
      return timer(4000).pipe(map(() => contactMock));
    }
    if (id === 'error') {
      return throwError(() => new HttpErrorResponse({ status: 500, statusText: 'Boom' }));
    }
    return of(null);
  },
  fetchSearchContact$: () => of([]),
};

@Component({
    imports: [ContactProfileCardComponent, TestIdDirective],
    providers: [{ provide: CamContactService, useValue: contactServiceMock }],
    template: `
    <cam-contact-profile-card camTestId="sf-slow" contactId="slow" />
    <cam-contact-profile-card camTestId="sf-error" contactId="error" />
    <cam-contact-profile-card camTestId="sf-empty" contactId="empty" />
  `
})
export class StateFlowsCase {}
